import template from './system_log.html';
import * as Utils from '../../lib/savanna_utils.js';
import parseLogs from '../../lib/sf_system_log.js';
import tr from '../../lib/default-translator.js';

class SystemLogViewModel
{
	constructor(page)
	{
		this.page = page;
		this.system_logs = ko.observableArray();
		this.query = ko.observable('');
		this.offset = ko.observable(0);
		this.limit = ko.observable(150);
		this.load_more_visible = ko.observable(true);
		this.logged_dates = ko.observableArray();
		this.loader = ko.observable(false);
	}
}

class SystemLogPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new SystemLogViewModel(this);
	}

	init()
	{
		document.title = tr('System Log');
		window.current_page_title(tr('System Log'));
	}

	async updateData()
	{
		this.viewModel.loader(true);

		let data = {
			schema: 'savanna',
			table: 'v_system_logs',
			limit: this.viewModel.limit(),
			offset: this.viewModel.offset()
		};

		// Filter results if the search field is populated
		if (this.viewModel.query().trim().length > 0)
		{
			data.filter = [
				{
					field: 'searchfield',
					op: 'LIKE',
					value: '%' + this.viewModel.query().toLowerCase().trim() + '%'
				}
			];
		}

		let res = await Grape.fetches.getJSON('/api/record', data);
		this.viewModel.loader(false);

		this.viewModel.load_more_visible(res.result_count > (this.viewModel.offset() + this.viewModel.limit()));
		let records = res.records || [];

		if (records.length === 0)
		{
			if (this.viewModel.offset() === 0)
			{
				this.viewModel.system_logs.removeAll();
				this.viewModel.logged_dates.removeAll();
			}
		}
		else
		{
			let parsed_records = parseLogs(records, this.viewModel.logged_dates);
			this.viewModel.system_logs(this.viewModel.system_logs().concat(parsed_records));
		}
		Utils.refresh_data_visible_roles();
	}

	async search()
	{
		this.viewModel.offset(0);
		this.viewModel.system_logs.removeAll();
		this.viewModel.logged_dates.removeAll();
		await this.updateData();
	}

	enterSearch(d, e)
	{
		if (e.keyCode === 13)
		{
			this.search();
			return false;
		}
		return true;
	}

	async load_more()
	{
		this.viewModel.offset(this.viewModel.offset() + this.viewModel.limit());
		await this.updateData();
	}
}

export default {
	route: '[/]admin/system_log',
	page_class: SystemLogPage,
	template: template,
	template_filename: 'translation/system_log'
};
